import {
    Button,
    CardActions,
    CardContent,
    CardHeader,
    Popover,
    PopoverProps,
} from '@mui/material';
import { Control, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface FilterWrapperProps {
    open: boolean;
    anchorEl: PopoverProps['anchorEl'];
    onClose: () => void;
    title: string;
    name: string;
    control: Control<FieldValues>;
    children: React.ReactNode;
}

const FilterWrapper = ({
    open,
    anchorEl,
    onClose,
    title,
    control,
    children,
}: FilterWrapperProps) => {
    const { t } = useTranslation();

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            disableRestoreFocus
            disablePortal
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: theme => theme.shape.xl,
                    },
                },
            }}
        >
            <CardHeader title={title} />
            <CardContent>{children}</CardContent>
            <CardActions sx={{ justifyContent: 'flex-end' }}>
                <Button disabled={!control._formState.isValid} type="submit">
                    {t('Apply')}
                </Button>
            </CardActions>
        </Popover>
    );
};

export default FilterWrapper;
